import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table, Badge } from 'react-bootstrap'
import Meta from '../components/Meta'

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  import { useNavigate } from 'react-router-dom';

  import { CodeView } from '../components/utils/CodeView'

  import { FeatureCards } from '../components/landing/FeatureCards'

export const LandingScreen = ({match, history}) => {

   
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [sectionType, setSectionType] = useState("all") 
    const [newModel, setNewModel] = useState("") 

    const navigateToGithub = () => {
        window.open('https://github.com/pixagan/Laeyerz', '_blank');
    }




    useEffect(() => {
        


    }, [])



    return(
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', textAlign: 'center', margin:'0px' }}>

<Meta title={'Laeyerz'} description={'Automate your tasks with AI. Laeyerz is a python library to build simple RAG applications and Agentic AI systems with minimal coding.'}/>
           
{/* Hero Section */}
<section style={{
    minHeight: 'clamp(420px, 60vh, 720px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: 'clamp(32px, 8vw, 80px) 20px',
    position: 'relative',
    overflow: 'visible',
    marginTop: '0px'
}}>
    {/* Background decoration */}
    <div style={{
        position: 'absolute',
        top: '-50%',
        right: '-20%',
        width: '300px',
        height: '200px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        zIndex: 1
    }}></div>
    <div style={{
        position: 'absolute',
        bottom: '-30%',
        left: '-10%',
        width: '200px',
        height: '200px',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '50%',
        zIndex: 1
    }}></div>

    <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row className="align-items-center">
            <Col className="text-start">
            <h1 className="fw-bold mb-3" style={{
                    fontFamily: 'Baskervville',
                    display: 'block',
                    // background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    lineHeight: 1.15,
                    fontSize: 'clamp(28px, 8vw, 70px)',
                    color: "#FFD700"
                }}>
                    Automate tasks with AI
                    
                </h1>
                <p className="h5 fw-bold mb-3" style={{
                    fontFamily: 'Baskervville',
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    lineHeight: 1.15,
                    fontSize: 'clamp(10px, 5vw, 56px)'
                }}>
                    Build Agents, Teams, Workflows
                    <span style={{
                        display: 'block',
                        background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        fontSize: 'clamp(10px, 6.5vw, 40px)',
                        color: "#FFD700"
                        
                    }}>
                        in minutes
                    </span>
                </p>

                <br />

                <p className="lead mb-4 text-center" style={{
                    maxWidth: '680px',
                    color: '#FFD700', //'rgba(255,255,255,0.9)',
                    fontFamily: 'Baskervville',
                    fontSize: 'clamp(14px, 6.5vw, 40px)',
                    lineHeight: 1.6,
                    margin: '0 auto',
                    fontStyle:'bold',
                    color:"white"
                }}>
                    Open-source, Graph based, in Python
                    {/* https://github.com/pixagan/laeyerz */}
                </p>

                <div className="d-flex gap-3 mb-2 justify-content-center" style={{ flexWrap: 'wrap' }}>
                    <Button
                        as={Link}
                        to="/docs/getting-started"
                        variant="light"
                        className="px-4 py-3 fw-semibold"
                        style={{
                            borderRadius: '12px',
                            fontSize: 'clamp(14px, 3.8vw, 18px)',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                            border: 'none'
                        }}
                    >
                        Get Started
                    </Button>
                    <Button
                        onClick={() => navigateToGithub()}
                        to="/examples"
                        variant="outline-light"
                        className="px-4 py-3 fw-semibold"
                        style={{
                            borderRadius: '12px',
                            fontSize: 'clamp(14px, 3.8vw, 18px)',
                            border: '2px solid rgba(255,255,255,0.8)'
                        }}
                    >
                        on Github
                    </Button>
                </div>
            </Col>
        </Row>
    </Container>
</section>

  <FeatureCards 
    header="Build Agents in minutes" 
    description="Add an Agent to your workflow to add a layer of intelligence to your task automation." 
    icon="🤖" 
    code={`
    reasoner_llm =  LLM("AgentSimple",  config={"api_key": api_key, "model":"gpt-5-mini"})
        agent = Agent(
    name="AgentSimple", 
    api_key_path=api_key_path,
    reasoner="reasoner_llm", 
    role="You are a travel planner", 
    instructions = "Given the city and the request, use the tools to provide the best information to the user", 
    tools={}
    )`} />

    <FeatureCards 
    header="Graph-based Agentic Workflows" 
    description="Automate your tasks with a graph-based agentic workflows. Create a workflow, add functional nodes, agents and execute the workflow." 
    icon="📦" 
    code={`test_flow = Flow()
llmNode = OpenAILLMNode(name="llmNode", config={"api_key": api_key})
vecstore = ChromaDBNode(name="vecstore")
test_flow.add_node(llmNode)
test_flow.add_node(vecstore)`} />





<FeatureCards
    header="Pre-built Component Nodes" 
    description="Jumpstart your AI workflows with our rapidly growing library of pre-built component nodes including LLMs, vector stores and more." 
    icon="📦" 
    code={`from laeyerz.nodes.llm.OpenAILLMNode import OpenAILLMNode
llm = OpenAILLMNode("Model", config={"api_key": api_key})
messages = [{role:"user", content:"Tell me about LLMs"}]
tools = []
model = "gpt-5-mini"
output = llm.call_llm(messages, model, tools )`} />


<FeatureCards
    header="Build Custom Nodes" 
    description="Need something specific? Extend our base Nodes to suit your use cases." 
    icon="🛠️" 
    code={`from laeyerz.flow.Node import Node
class CustomNode(Node):
    def __init__(self, name):
        super().__init__(name)
    def run(self, input):
        return input`} />

               



           {/* CTA Section */}
           <section style={{
               padding: '100px 0',
               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
               textAlign: 'center'
           }}>
               <Container>
                   <Row className="justify-content-center">
                       <Col lg={8}>
                           <h2 className="display-4 fw-bold mb-4" style={{
                               fontFamily: "Baskervville",
                               color: 'white',
                               lineHeight: '1.3'
                           }}>
                               Examples
                           </h2>
                           <p className="lead mb-5" style={{ 
                               color: 'rgba(255,255,255,0.9)', 
                               fontFamily: "Baskervville",
                               fontSize: '1.2rem',
                               lineHeight: '1.6'
                           }}>
                               Checkout examples of workflows built with Laeyerz.
                           </p>
                           <div className="d-flex gap-3 justify-content-center" style={{ flexWrap: 'wrap' }}>
                               <Button 
                                   as={Link} 
                                   to="/docs/getting-started" 
                                   variant="light" 
                                   className="px-5 py-3 fw-semibold" 
                                   style={{ 
                                       borderRadius: '12px', 
                                       fontSize: '1.1rem',
                                       boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                       border: 'none'
                                   }}
                               >
                                   Get Started
                               </Button>
                               <Button 
                                   as={Link} 
                                   to="/examples" 
                                   variant="outline-light" 
                                   className="px-5 py-3 fw-semibold" 
                                   style={{ 
                                       borderRadius: '12px', 
                                       fontSize: '1.1rem',
                                       border: '2px solid rgba(255,255,255,0.8)'
                                   }}
                               >
                                   View Examples
                               </Button>
                           </div>
                       </Col>
                   </Row>
               </Container>
           </section>


           
        </div>
    )
}

export default LandingScreen